var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaPreferitiFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.35,17.89h2.91a.53355.53355,0,0,1,.53.53.525.525,0,0,1-.53.52H9.11A.52337.52337,0,0,1,8.6,18.51.49784.49784,0,0,1,8.61,18.3c-.43995-.17-.83-.35-1.17-.52-.2-.1-.37-.19-.52-.27-.14-.08-.26-.15-.36-.2a1.49676,1.49676,0,0,1-.23-.15H6.32A13.38516,13.38516,0,0,1,0,5.79.41017.41017,0,0,1,.01,5.68,5.78037,5.78037,0,0,1,10,1.82a5.78037,5.78037,0,0,1,9.99,3.86A.41017.41017,0,0,1,20,5.79,13.40282,13.40282,0,0,1,12.35,17.89Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaPreferitiFill);
export default __webpack_public_path__ + "static/media/iconaPreferitiFill.8566c263eb31bfea706ae959a4713a4c.svg";
export { ForwardRef as ReactComponent };